import React, { useEffect, useState } from "react";
import { functionService } from "../../lib/functions";
import style from "./index.module.scss";
import { useNavigate } from "react-router-dom";

function Login() {
  let navigate = useNavigate();
  useEffect(() => {
    const getToken = localStorage.getItem("jwtToken");
    if (getToken) {
      navigate(`/demand-table`, { replace: true });
      // Router.replace("/assessment-question");
    }
  }, []);

  const [emailValue, updateEmailValue] = useState("");
  const [passwordValue, updatePasswordValue] = useState("");
  const [apiResponse, updateApiResponse] = useState("");
  const [errorResponse, updateerrorResponse] = useState(null);
  const signInHandler = async () => {
    let formData = {
      email: emailValue,
      password: passwordValue,
    };
    const authResponse = await functionService.post(`auth/login`, formData);

    if (authResponse.response && authResponse.response.status === 200) {
      updateApiResponse(authResponse?.response);
      updateerrorResponse(null);
      
      const loginData = authResponse.response.data.data;
      
      // Store access token
      localStorage.setItem("jwtToken", loginData.token);
      
      // Store refresh token (if backend provides it)
      if (loginData.refreshToken) {
        localStorage.setItem("refreshToken", loginData.refreshToken);
      }
      
      // Store token expiry time (4 hours from now)
      localStorage.setItem("tokenExpiry", Date.now() + (4 * 60 * 60 * 1000));
      
      localStorage.setItem(
        "adminAccess",
        loginData.admin_access
      );
      localStorage.setItem("user_name", loginData.name);
      localStorage.setItem("userId", loginData.userId);
      localStorage.setItem("userEmail", loginData.email);

      const adminAccess = authResponse.response.data.data.adminAccess;

      // Redirect to demand table
      navigate(`/demand-table`, { replace: true });
    } else {
      localStorage.removeItem("jwtToken");
      updateerrorResponse(
        authResponse?.error?.response?.data?.meta?.message +
          ". Please Contact Admin!!"
      );
    }
  };
  return (
    <React.Fragment>
      <div className={style.containerset}>
        <div className={style.loginArea}>
          <div className="image">
            <img src="./coffeee_logo.svg" height="100" width="100" />
          </div>
          {errorResponse != null ? (
            <div className={style.errorMsg}>{errorResponse}</div>
          ) : (
            ""
          )}
          <div className={style.formStructure}>
            <input
              type="text"
              value={emailValue}
              onChange={(e) => {
                updateEmailValue(e.target.value);
              }}
              placeholder={"Email"}
            />
            <input
              type="password"
              value={passwordValue}
              onChange={(e) => {
                updatePasswordValue(e.target.value);
              }}
              placeholder={"Password"}
            />
          </div>
          <button onClick={signInHandler}>Login</button>
        </div>
      </div>
      {/* <button  onClick={() =>  loginButtonHandler()}>Log In</button> */}
    </React.Fragment>
  );
}

export default Login;
